import { CONCEPTS } from '@rover/rsdk/src/concepts';
import { AnalyticsEvent, ConsentPurpose } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when user clicks on "Has low acceptance rate" checkbox inside Other filter in search page.
 *
 * &nbsp;
 */
export class SearchFilterLowBookingCheckboxClickEvent extends AnalyticsEvent {
  eventName = 'search-filter-low-booking-checkbox';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;
}
